var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnbChain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    height: 32,
    width: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    className: "uk-preserve",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2561 23.9316V26.6209L15.9658 28L13.7439 26.6209V23.9316L15.9658 25.3107L18.2561 23.9316ZM6 14.6203L8.22186 16.0006V20.6206L12.0607 22.9662V25.6555L6 21.9997V14.6203ZM25.9327 14.6203V21.9997L19.8046 25.6555V22.9662L23.6424 20.6206V16.0006L25.9327 14.6203ZM19.8046 10.9657L22.0938 12.3414V15.0341L18.2561 17.3797V22.0687L16.0331 23.4489L13.8113 22.0687V17.3797L9.83884 15.0341V12.3414L12.128 10.9623L15.9658 13.3102L19.8046 10.9657ZM9.83884 16.9715L12.0607 18.3473V21.0366L9.83884 19.6574V16.9715ZM22.0938 16.9715V19.6608L19.872 21.0399V18.3473L22.0938 16.9715ZM8.22186 8.63006L10.5121 10.0058L8.22186 11.3794V14.0687L6 12.6896V10.0058L8.22186 8.63006ZM23.7097 8.63006L26 10.0058V12.6896L23.7097 14.0687V11.3794L21.4879 10.0058L23.7097 8.63006ZM15.9658 8.63006L18.2561 10.0058L15.9658 11.3794L13.7439 10.0058L15.9658 8.63006ZM15.9658 4L22.0938 7.65466L19.872 9.03489L16.0331 6.68928L12.1237 9.03489L9.90943 7.65466L15.9658 4Z",
    className: "uk-preserve",
    fill: "#F3BA2F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbChain);
export default __webpack_public_path__ + "static/media/bnb-chain.53d6a41bd1bdf462757e80f3bc1b435f.svg";
export { ForwardRef as ReactComponent };